<script setup>
const { topPositionClasses } = useHeaderConfig()
</script>

<template>
  <Teleport to="#sidebar-portal">
    <div class="w-270px">
      <div
        class="fixed bottom-0 left-0 z-fixed"
        :class="[topPositionClasses]"
      >
        <slot />
      </div>
    </div>
  </Teleport>
</template>
